import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable, catchError, map, of } from 'rxjs';
import { httpGetProductGetUserHasPayroll } from '../api/http/get-product-get-user-has-payroll';

export const hasPayrollGuard = (): CanActivateFn => (): Observable<boolean | UrlTree> => {
  const http = inject(HttpClient);
  const router = inject(Router);
  return httpGetProductGetUserHasPayroll(http).pipe(
    catchError(() => of(false)),
    map((result) => {
      return result ? result : router.parseUrl('/page-not-found');
    })
  );
};
